import { DItemConfiguracion, DItemRangoCasillas } from '@dian-cmp/formulario';
import { DInterfaceConfiguracionFormulario, DTipoOperacionAritmetica, DTipoRegla } from '@dian-cmp/formulario';
import { IDObserverTimerSession } from '@dian/core';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';
import { DContextoUsuarioServicio } from '@dian/api-identidad';

export class DObserverTimerSessionApp implements IDObserverTimerSession{
    
    constructor(
        private dNotificacionServicio: DNotificacionServicio,
        private dContextoUsuarioServicio: DContextoUsuarioServicio
    ) {}
    
    public cerrarSession(){
        let dialogo = this.dNotificacionServicio.mostrarDialogoInformacion('Su sesión ha expirado');
        dialogo.afterClosed().subscribe(result => {
            this.dContextoUsuarioServicio.logOut();
        });
    }
}

export class DFormularioConfiguracion implements DInterfaceConfiguracionFormulario {

    public USA_FORMULARIO_PAGO_NUEVO: boolean = true;
    public SOLO_USUARIO_INVITADO: boolean = false;
    public NUMERO_FORMULARIO = 300;//numero formulario ejemplo
    public VERSION_FORMATO = 4;//numero de la version del formato
    public PUEDE_SUBIR_ARCHIVOS: boolean = false;
    public USA_CERTIFICADO_FIRMA_OBLIGATORIO = true;
    public CASILLA_NIT:string = 'cs_id_5'; //le indica al framework cual es la casilla del nit 
    public CASILLA_ES_CORRECCION:string = 'cs_id_25';//le indica al framework cual es la casilla de correccion
    public CASILLA_SANCION:string = 'cs_id_87';//le indica al framework cual es la casilla de sancion
    public CASILLA_NUM_FORM_ANTERIOR:string = 'cs_id_26';//le indica al framework cual es la casilla del numero de formulario anterior
    public RANGO_CUERPO = new DItemRangoCasillas(24, 111);//rango ejemplo
    public REGLAS_FORMULARIO:Array<DItemConfiguracion> = [//modelo ejemplo
        //declarante
        {casilla: 'cs_id_24', tipoDato:'string', redondear: false, editable: false, validaciones:{}},
        {casilla: 'cs_id_25', tipoDato:'number', redondear: false, editable: false, validaciones:{}},
        {casilla: 'cs_id_26', tipoDato:'string', redondear: false, editable: false, validaciones:{}},
        //ingresos
        {casilla: 'cs_id_27', tipoDato:'number', redondear: true, editable: true, validaciones:{}},
        {casilla: 'cs_id_28', tipoDato:'number', redondear: true, editable: true, validaciones:{}},
        {casilla: 'cs_id_29', tipoDato:'number', redondear: true, editable: true, validaciones:{}},
        {casilla: 'cs_id_30', tipoDato:'number', redondear: true, editable: true, validaciones:{}},
        {casilla: 'cs_id_31', tipoDato:'number', redondear: true, editable: true, validaciones:{}},
        {casilla: 'cs_id_32', tipoDato:'number', redondear: true, editable: true, validaciones:{}},
        {casilla: 'cs_id_33', tipoDato:'number', redondear: true, editable: true, validaciones:{}},
        {casilla: 'cs_id_34', tipoDato:'number', redondear: true, editable: false, validaciones:{}},
        {casilla: 'cs_id_35', tipoDato:'number', redondear: true, editable: true, validaciones:{}},
        {casilla: 'cs_id_36', tipoDato:'number', redondear: true, editable: true, validaciones:{}},
        {casilla: 'cs_id_37', tipoDato:'number', redondear: true, editable: true, validaciones:{}},
        {casilla: 'cs_id_38', tipoDato:'number', redondear: true, editable: true, validaciones:{}}, 
        {casilla: 'cs_id_39', tipoDato:'number', redondear: true, editable: true, validaciones:{}}, 
        {casilla: 'cs_id_40', tipoDato:'number', redondear: true, editable: true, validaciones:{}}, 
        {casilla: 'cs_id_41', tipoDato:'number', redondear: true, editable: false, validaciones:{}}, 
        {casilla: 'cs_id_42', tipoDato:'number', redondear: true, editable: true, validaciones:{}},         
        {casilla: 'cs_id_43', tipoDato:'number', redondear: false, editable: false, validaciones:{}}, 
        //compras       
        {casilla: 'cs_id_44', tipoDato:'number', redondear: true, editable: true, validaciones:{}},
        {casilla: 'cs_id_45', tipoDato:'number', redondear: true, editable: true, validaciones:{}},
        {casilla: 'cs_id_46', tipoDato:'number', redondear: true, editable: true, validaciones:{}},
        {casilla: 'cs_id_47', tipoDato:'number', redondear: true, editable: true, validaciones:{}},
        {casilla: 'cs_id_48', tipoDato:'number', redondear: true, editable: true, validaciones:{}},
        {casilla: 'cs_id_49', tipoDato:'number', redondear: true, editable: true, validaciones:{}},
        {casilla: 'cs_id_50', tipoDato:'number', redondear: true, editable: true, validaciones:{}},
        {casilla: 'cs_id_51', tipoDato:'number', redondear: true, editable: true, validaciones:{}},
        {casilla: 'cs_id_52', tipoDato:'number', redondear: true, editable: true, validaciones:{}},
        {casilla: 'cs_id_53', tipoDato:'number', redondear: true, editable: true, validaciones:{}},
        {casilla: 'cs_id_54', tipoDato:'number', redondear: true, editable: true, validaciones:{}},
        {casilla: 'cs_id_55', tipoDato:'number', redondear: true, editable: false, validaciones:{}},
        {casilla: 'cs_id_56', tipoDato:'number', redondear: true, editable: true, validaciones:{}},        
        {casilla: 'cs_id_57', tipoDato:'number', redondear: true, editable: false, validaciones:{}},
        //liquidación privada
        {casilla: 'cs_id_58', tipoDato:'number', redondear: true, editable: true, validaciones:{}},
        {casilla: 'cs_id_59', tipoDato:'number', redondear: true, editable: true, validaciones:{}}, 
        {casilla: 'cs_id_60', tipoDato:'number', redondear: true, editable: true, validaciones:{}},
        {casilla: 'cs_id_61', tipoDato:'number', redondear: true, editable: false, validaciones:{}},
        {casilla: 'cs_id_62', tipoDato:'number', redondear: true, editable: true, validaciones:{}},       
        {casilla: 'cs_id_63', tipoDato:'number', redondear: true, editable: true, validaciones:{}},
        {casilla: 'cs_id_64', tipoDato:'number', redondear: true, editable: true, validaciones:{}},
        {casilla: 'cs_id_65', tipoDato:'number', redondear: true, editable: true, validaciones:{}},
        {casilla: 'cs_id_66', tipoDato:'number', redondear: true, editable: true, validaciones:{}},
        {casilla: 'cs_id_67', tipoDato:'number', redondear: true, editable: false, validaciones:{}},
        {casilla: 'cs_id_68', tipoDato:'number', redondear: true, editable: true, validaciones:{}},
        {casilla: 'cs_id_69', tipoDato:'number', redondear: true, editable: true, validaciones:{}},
        {casilla: 'cs_id_70', tipoDato:'number', redondear: true, editable: true, validaciones:{}},
        {casilla: 'cs_id_71', tipoDato:'number', redondear: true, editable: true, validaciones:{}},
        {casilla: 'cs_id_72', tipoDato:'number', redondear: true, editable: true, validaciones:{}},
        {casilla: 'cs_id_73', tipoDato:'number', redondear: true, editable: true, validaciones:{}},
        {casilla: 'cs_id_74', tipoDato:'number', redondear: true, editable: true, validaciones:{}},
        {casilla: 'cs_id_75', tipoDato:'number', redondear: true, editable: true, validaciones:{}},
        {casilla: 'cs_id_76', tipoDato:'number', redondear: true, editable: true, validaciones:{}},
        {casilla: 'cs_id_77', tipoDato:'number', redondear: true, editable: false, validaciones:{}},
        {casilla: 'cs_id_78', tipoDato:'number', redondear: true, editable: true, validaciones:{}},
        {casilla: 'cs_id_79', tipoDato:'number', redondear: true, editable: true, validaciones:{}},
        {casilla: 'cs_id_80', tipoDato:'number', redondear: true, editable: true, validaciones:{}},
        {casilla: 'cs_id_81', tipoDato:'number', redondear: true, editable: false, validaciones:{}},
        {casilla: 'cs_id_82', tipoDato:'number', redondear: true, editable: false, validaciones:{}},
        {casilla: 'cs_id_83', tipoDato:'number', redondear: true, editable: false, validaciones:{}},
        {casilla: 'cs_id_84', tipoDato:'number', redondear: true, editable: true, validaciones:{}},
        {casilla: 'cs_id_85', tipoDato:'number', redondear: true, editable: true, validaciones:{}},
        {casilla: 'cs_id_86', tipoDato:'number', redondear: true, editable: false, validaciones:{}},
        {casilla: 'cs_id_87', tipoDato:'number', redondear: true, editable: true, validaciones:{}},        
        {casilla: 'cs_id_88', tipoDato:'number', redondear: true, editable: false, validaciones:{}},
        {casilla: 'cs_id_89', tipoDato:'number', redondear: true, editable: false, validaciones:{}},
        //control de saldos
        {casilla: 'cs_id_90', tipoDato:'number', redondear: true, editable: true, validaciones:{}},
        {casilla: 'cs_id_91', tipoDato:'number', redondear: true, editable: true, validaciones:{}},
        {casilla: 'cs_id_92', tipoDato:'number', redondear: true, editable: true, validaciones:{}},
        {casilla: 'cs_id_93', tipoDato:'number', redondear: true, editable: false, validaciones:{}},
        //anticipos IVA
        {casilla: 'cs_id_94', tipoDato:'number', redondear: true, editable: true, validaciones:{}},
        {casilla: 'cs_id_95', tipoDato:'number', redondear: true, editable: true, validaciones:{}},
        {casilla: 'cs_id_96', tipoDato:'number', redondear: true, editable: true, validaciones:{}},
        {casilla: 'cs_id_97', tipoDato:'number', redondear: true, editable: true, validaciones:{}}, 
        {casilla: 'cs_id_98', tipoDato:'number', redondear: true, editable: true, validaciones:{}},
        {casilla: 'cs_id_99', tipoDato:'number', redondear: true, editable: true, validaciones:{}},
        {casilla: 'cs_id_100', tipoDato:'number', redondear: true, editable: false, validaciones:{}},
        //firmas
        {casilla: 'cs_id_101', tipoDato:'string', redondear: false, editable: true, validaciones:{}},
        {casilla: 'cs_id_102', tipoDato:'string', redondear: false, editable: false, validaciones:{}},

        //casillas nuevas Catatumbo
        {casilla: 'cs_id_104', tipoDato:'number', redondear: true, editable: true, validaciones:{}},
        {casilla: 'cs_id_105', tipoDato:'number', redondear: true, editable: true, validaciones:{}},
        {casilla: 'cs_id_106', tipoDato:'number', redondear: true, editable: true, validaciones:{}},
        {casilla: 'cs_id_107', tipoDato:'number', redondear: true, editable: true, validaciones:{}},
        {casilla: 'cs_id_108', tipoDato:'number', redondear: true, editable: true, validaciones:{}},
        {casilla: 'cs_id_109', tipoDato:'number', redondear: true, editable: true, validaciones:{}},
        {casilla: 'cs_id_110', tipoDato:'number', redondear: true, editable: true, validaciones:{}},
        {casilla: 'cs_id_111', tipoDato:'number', redondear: true, editable: true, validaciones:{}}
    ];

}



// WEBPACK FOOTER //
// D:/GIT/F300/V4/ng_formulario300v4/src/app/configuracion/dformulario-configuracion.ts